import { IReducerFn } from 'context/type';
import { TDeviceSizeState } from './deviceSize.type';

export const deviceSizeReducer: IReducerFn<TDeviceSizeState> = (state, { type }) => {
  switch (type) {
    case 'set_is_mobile':
      return {
        ...state,
        isDesktop: false,
        isTablet: false,
        isMobile: true,
      };
    case 'set_is_tablet':
      return {
        ...state,
        isDesktop: false,
        isTablet: true,
        isMobile: false,
      };
    case 'set_is_desktop':
      return {
        ...state,
        isDesktop: true,
        isTablet: false,
        isMobile: false,
      };
    default:
      return state;
  }
};

deviceSizeReducer.key = 'deviceSize';
deviceSizeReducer.initialState = {
  isDesktop: true,
  isTablet: false,
  isMobile: false,
};
